import React, {Fragment} from 'react';
import { useAuth } from '../../Context/Context';
import { WavyLink } from "react-wavy-transitions";

import img1 from "../../Images/Servicios/PaginaWeb/1.png"
import img2 from "../../Images/Servicios/PaginaWeb/4.png"
import img3 from "../../Images/Servicios/PaginaWeb/3.png"

import img4 from "../../Images/Servicios/Desarrollo/1.png"
import img5 from "../../Images/Servicios/Desarrollo/2.png"
import img6 from "../../Images/Servicios/Desarrollo/3.png"
import img7 from "../../Images/Servicios/Desarrollo/4.png"
import img8 from "../../Images/Servicios/Desarrollo/5.png"
import img9 from "../../Images/Servicios/Desarrollo/6.png"

import icon1 from "../../Images/Servicios/Iconos/1.png";
import icon2 from "../../Images/Servicios/Iconos/2.png";
import icon3 from "../../Images/Servicios/Iconos/3.png";
import icon4 from "../../Images/Servicios/Iconos/4.png"; 
import icon5 from "../../Images/Servicios/Iconos/8.png"; 
import icon6 from "../../Images/Servicios/Iconos/6.png"; 

import Portafolio from '../../Components/Portafolio';

import imgServiciosBlanco from "../../Images/servicios_blanco.png";
import Efectos from '../../Components/Efectos';
import Contacto from '../../Components/Contacto';


const PaginaWeb = () => {
    const { direction, cambio } = useAuth();

    return(
        <Fragment>
            <div>
                <div className='fondo_servicio_8'>
                    <div className='cont_1 contenedor_tablet_2 cont_movil_1'>
                            <p className='sub_titulo_nv_4' style={{color:"#ffffff"}}>
                                <span className='titulo_nv_2' style={{color:"#ED3E75"}}>
                                    Páginas web <br/>
                                </span>
                                Personaliza tu sitio
                            </p>
                            <div>
                                <p>
                                    Diseñamos y programamos páginas web, catálogos, menús digitales y más para complementar la carta de presentación de tu empresa. 
                                </p>
                                <p>
                                    Nuestras páginas web son a la medida <br/>
                                    y con un diseño 100% personalizado.
                                </p>
                            </div>
                            
                    </div>
                    {window.screen.width <= 550 ? (
                        <div>
                            <div>
                                <Efectos activado={true}>
                                    <img class="scroll-element js-scroll fade-in-bottom" src={img2} alt="" style={{width:"100%", maxWidth:"1485px"}}/>
                                </Efectos>
                                <p className='center cont_1' style={{color:"#707070"}}>
                                    <b>Utilizamos las mejores técnicas</b> de programación y estándares de diseño, 
                                    haciendo plataformas escalables, permitiendo agregar nuevas funcionalidades 
                                    en cualquier momento.
                                </p>
                            </div>
                        </div>
                    ) : (

                        <div>
                            <div>
                                <Efectos activado={true}>
                                    <img class="scroll-element js-scroll fade-in-bottom" src={img1} alt="" style={{width:"100%", maxWidth:"1485px"}}/>
                                </Efectos>
                                <p className='center cont_7' style={{color:"#707070"}}>
                                    <b>Utilizamos las mejores técnicas</b> de programación y estándares de diseño, 
                                    haciendo plataformas escalables, permitiendo agregar nuevas funcionalidades 
                                    en cualquier momento.
                                </p>
                            </div>
                        </div>
                    )}
                </div>
                

                <div className='cont_2'>
                    <p className='titulo_nv_1 center' style={{color:"#BF1F60"}}>
                        ¿Qué incluye?
                    </p>
                    <div style={{display:"flex", justifyContent:"space-evenly", flexWrap:"wrap", alignItems:"stretch"}}>
                        <div className='flex_1' style={{marginTop:"0"}}>
                            <div className='box_1' style={{marginTop:"0"}}>
                                <img src={icon1} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Sitio web responsivo
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Podrán ver y comprar productos de tu tienda desde celulares, tabletas y  computadoras.
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon4} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Diseño personalizado
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Todos nuestros diseños son únicos, personalizados, atractivos y sobre todo funcionales.
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon5} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Administrador web
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Creamos un panel administrativo para que puedas editar el contenido de la página, sin depender de nosotros. Incluye capacitación.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='flex_1' style={{marginTop:"0"}}>
                            <div className='box_1' style={{marginTop:"0"}}>
                                <img src={icon2} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Certificado SSL
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Protegemos todos los datos que se recaben en tu sitio gracias al protocolo de seguridad 
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon3} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Optimización SEO
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Utilizamos las mejores técnicas y prácticas de programación para favorecer el posicionamiento orgánico de la página web en Google.
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon6} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Hospedaje y Dominio
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Hospeda tu página de manera segura, ¿y lo mejor? GRATIS durante todo el primer año.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div id='seo' className='flex_padre_1 cont_4'>
                    <div className='flex_2'>
                        <Efectos>
                            <img class="scroll-element js-scroll fade-in-bottom imagen_movil_servicios_3" src={img3} alt="" style={{ width:"100%", maxWidth:"1485px"}}/>
                        </Efectos>
                    </div>
                    <div className='flex_3 ' style={{textAlign:"center"}}>
                        <p className='titulo_nv_1' style={{marginBottom:"0"}}>
                            <span className='titulo_nv_2' style={{color:"#ED3E75"}}>
                                Optimización SEO <br/>
                            </span>
                            Más fácil de encontrar
                        </p>
                        <div className='cont_3'>
                            <p>
                                Realizaremos un conjunto de acciones orientadas a mejorar el posicionamiento de 
                                tu sitio web en la lista de resultados de Google, Bing, u otros buscadores de 
                                internet.
                            </p>
                            <p>
                                La efectividad del SEO se demuestra en la respuesta del tráfico que genere un tipo 
                                de contenido en la web, definamos una <b style={{color:"#2A79B0"}}>estrategia de optimización de SEO.</b> 
                            </p>
                        </div>
                        <div style={{display:"flex", justifyContent:"center", marginTop:"40px"}}>
                            <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                                <p class="btn_1" onClick={cambio} style={{margin:"0px", backgroundColor:"#6D1867", color:"#fff"}}>
                                    Cotiza tu proyecto
                                </p>
                            </WavyLink>
                            {/* <div className='btn_1' style={{margin:"0px", backgroundColor:"#6D1867"}}>
                                <a href="/contacto" style={{color:"#fff"}}>
                                    <p>
                                        Cotiza tu proyecto
                                    </p>
                                </a>
                            </div> */}
                        </div>
                    </div>    
                </div>
                <div className='center'>
                    <p className='titulo_nv_1' style={{marginBottom:"0"}}>
                        ¿Cómo hacemos tu <br/>
                        <span className='titulo_nv_2' style={{color:"#A741AF"}}>página web?</span>
                    </p>
                    <p className='cont_7' style={{color:"#707070"}}>
                        El proceso de trabajo de nuestras 
                        <b style={{color:"#BF1F60"}}> páginas web </b> 
                        se divide en distintas etapas,
                        cada una tan importante como la anterior.
                    </p>
                </div>
                {window.screen.width <= 992 ? (
                    <div className='cont_2'style={{display:"flex", justifyContent:"center", flexWrap:"wrap"}}>
                        <div className='box_3'>
                            <img src={img4} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#42D4FC" , margin:"0px"}}>
                                    Definición del proyecto.
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Primero platicamos contigo para saber la meta a 
                                    alcanzar con este proyecto, cubrir tus 
                                    necesidades y sobre todo tomar la esencia de tu 
                                    empresa. <br/>
                                    Te damos la <b>cotización de tu proyecto.</b> 
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img5} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#2A79B0" , margin:"0px"}}>
                                    Diseño y experiencia
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Nuestro equipo de diseño se encargará de crear 
                                    una experiencia visual única, limpia y atractiva, 
                                    priorizando la accesibilidad para todos los 
                                    usuarios. Te presentaremos <b>la visualización de 
                                    tu página</b> para que puedas personalizarla aún más, <br/>
                                    antes de aprobarla.
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img6} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#134263" , margin:"0px"}}>
                                    Desarrollo del sitio web
                                </b >
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Nuestros ingenieros con el uso de la tecnología 
                                    y los lenguajes de programación más novedosos 
                                    <b> desarrollan el diseño</b> y se enfocan en la correcta 
                                    adaptación en todos los dispositivos. También 
                                    <b> seleccionarás tu dominio</b> y otros aspectos 
                                    técnicos de tu página.
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img7} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#A741AF" , margin:"0px"}}>
                                    Control de calidad
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Después de elegir los <b>métodos de pago</b> para tu 
                                    tienda y una vez finalizado el desarrollo, 
                                    <b> realizamos las pruebas de calidad</b> para 
                                    asegurarnos de que el funcionamiento sea 
                                    óptimo y así garantizar el uso perfecto del sitio 
                                    web.
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img8} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                    Entregamos tu página 
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}> 
                                    Tu web estará en el servidor y será <b>totalmente 
                                    funcional.</b> Además, <b>ofrecemos una 
                                    capacitación</b> para que puedas administrarla de 
                                    manera independiente.
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img9} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                    Soporte 
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}> 
                                    Estamos aquí siempre que nos necesites, 
                                    ofrecemos permanente comunicación de 
                                    todo nuestro equipo para apoyarte en 
                                    cualquier situación.
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='cont_2' style={{display:"flex", justifyContent:"center", marginTop:"50px"}}>
                        <div className='flex_lateral'>
                            <div className='box_3'>
                            </div>
                            <div className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#2A79B0" , margin:"0px"}}>
                                    Diseño y experiencia
                                </b>
                                <p  style={{color:"#707070" , margin:"0px"}}>
                                    Nuestro equipo de diseño se encargará de crear 
                                    una experiencia visual única, limpia y atractiva, 
                                    priorizando la accesibilidad para todos los 
                                    usuarios. Te presentaremos <b>la visualización de 
                                    tu página</b> para que puedas personalizarla aún más, <br/>
                                    antes de aprobarla.
                                </p>
                            </div>
                            <div className='box_3'>
                                
                            </div>
                            <div className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#A741AF" , margin:"0px"}}>
                                    Control de calidad
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Después de elegir los <b>métodos de pago</b> para tu 
                                    tienda y una vez finalizado el desarrollo, 
                                    <b> realizamos las pruebas de calidad</b> para 
                                    asegurarnos de que el funcionamiento sea 
                                    óptimo y así garantizar el uso perfecto del sitio 
                                    web.
                                </p>
                            </div>
                        </div>
                        <div className='flex_centro'>
                            <img src={imgServiciosBlanco} className="effect_fondo" alt="" style={{width:"100%"}} />
                            <div className='box_4'>
                                <div>
                                    <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                        Soporte 
                                    </b>
                                    <p style={{color:"#707070" , margin:"0px"}}> 
                                        Estamos aquí siempre que nos necesites, 
                                        ofrecemos permanente comunicación de 
                                        todo nuestro equipo para apoyarte en 
                                        cualquier situación.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='flex_lateral'>
                            <div className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#42D4FC" , margin:"0px"}}>
                                    Definición del proyecto.
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Primero platicamos contigo para saber la meta a 
                                    alcanzar con este proyecto, cubrir tus 
                                    necesidades y sobre todo tomar la esencia de tu 
                                    empresa. <br/>
                                    Te damos la <b>cotización de tu proyecto.</b> 
                                </p>
                            </div>
                            <div className='box_3'>
                            </div>
                            <div  className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#134263" , margin:"0px"}}>
                                    Desarrollo del sitio web
                                </b >
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Nuestros ingenieros con el uso de la tecnología 
                                    y los lenguajes de programación más novedosos 
                                    <b> desarrollan el diseño</b> y se enfocan en la correcta 
                                    adaptación en todos los dispositivos. También 
                                    <b> seleccionarás tu dominio</b> y otros aspectos 
                                    técnicos de tu página.
                                </p>
                            </div>
                            <div className='box_3'>
                                
                            </div>
                            <div  className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                    Entregamos tu página 
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}> 
                                    Tu web estará en el servidor y será <b>totalmente 
                                    funcional.</b> Además, <b>ofrecemos una 
                                    capacitación</b> para que puedas administrarla de 
                                    manera independiente.
                                </p>
                            </div>
                        </div>
                        
                    </div>
                )}

                <Portafolio />
                <Contacto/>
                
            </div>
        </Fragment>
    )
}

export default PaginaWeb;